import i18n from '../locales/index'
import MobileSale from "@/config/mobile_sale_abi";
import Usdt from "@/config/usdt";
import Web3 from "web3";
import ProductManager from "@/config/productManager";
import SaleStorage from "@/config/sale_storage";
import store from '@/store';  // 导入 store

// 存储合约配置的对象
let contractConfigs = {
    mobileSale: {
        abi: MobileSale.abi,
        address: process.env.NODE_ENV === 'development' ? MobileSale.testAddress : MobileSale.address
    },
    usdt: {
        abi: Usdt.abi,
        address: process.env.NODE_ENV === 'development' ? Usdt.testAddress : Usdt.address
    },
    productManager: {
        abi: ProductManager.abi,
        address: process.env.NODE_ENV === 'development' ? ProductManager.testAddress : ProductManager.address,
        targetProductName: "Test Product"
    },
    saleStorage: {
        abi: SaleStorage.abi,
        address: process.env.NODE_ENV === 'development' ? SaleStorage.testAddress : SaleStorage.address
    }
};
console.log("contractConfigs",contractConfigs, process.env.NODE_ENV)
// 更新合约配置的方法
function updateContractConfig(contractName, newConfig) {
    if (contractConfigs[contractName]) {
        contractConfigs[contractName] = {
            ...contractConfigs[contractName],
            ...newConfig
        };
        console.log(`Contract ${contractName} config updated:`, contractConfigs[contractName]);
    }
}

// 获取当前合约配置
function getContractConfig(contractName) {
    return contractConfigs[contractName];
}

// 获取 Web3 实例的辅助函数
function getWeb3Instance() {
    const provider = window.myprovider || window.ethereum || 
        new Web3.providers.HttpProvider("http://127.0.0.1:8545/");
    return new Web3(provider);
}

//业务合约
function getMobileSaleContract(){
    try {
        const web3 = getWeb3Instance();
        const config = getContractConfig('mobileSale');
        return new web3.eth.Contract(config.abi, config.address);
    } catch (error) {
        console.error('Error creating MobileSale contract:', error);
        throw error;
    }
}

//代币合约
function getCoinContract(){    
    try {
        const web3 = getWeb3Instance();
        const config = getContractConfig('usdt');
        return new web3.eth.Contract(config.abi, config.address);
    } catch (error) {
        console.error('Error creating Coin contract:', error);
        throw error;
    }
}

//产品管理合约
function getProductManagerContract(){
    try {
        const web3 = getWeb3Instance();
        const config = getContractConfig('productManager');
        return new web3.eth.Contract(config.abi, config.address);
    } catch (error) {
        console.error('Error creating ProductManager contract:', error);
        throw error;
    }
}

// 获取存储合约
function getSaleStorageContract() {
    try {
        const web3 = getWeb3Instance();
        const config = getContractConfig('saleStorage');
        return new web3.eth.Contract(config.abi, config.address);
    } catch (error) {
        console.error('Error creating SaleStorage contract:', error);
        throw error;
    }
}

// 产品 ID 从产品管理合约的 getProductByIndex 读取，再 getProduct(productId) 取详情
async function updateMobileSaleContractAddress() {
    try {
        const productManagerContract = getProductManagerContract();
        const count = await productManagerContract.methods.getProductCount().call();
        const productId = await productManagerContract.methods.getProductByIndex(parseInt(count) - 2).call();
        const productInfo = await productManagerContract.methods.getProduct(productId).call();
        console.log('productInfo', productInfo)
        if(process.env.NODE_ENV === 'production'){
            updateContractConfig('mobileSale', {
                address: productInfo.strategyContract // 使用 strategyContract 作为合约地址
            });
        }

        console.log('MobileSale contract address updated successfully');
                    
        // 更新存储合约地址
        const mobileSaleContract = getMobileSaleContract();
        if(process.env.NODE_ENV === 'production'){
            const storageAddress = await mobileSaleContract.methods.storageContract().call();
            if (storageAddress) {
                updateContractConfig('saleStorage', {
                    address: storageAddress
                });
                console.log('SaleStorage contract address updated successfully');
            }
        }

        // 将产品信息映射并存储到 store
        const mappedProductInfo = {
            id: productInfo.id,
            name: productInfo.name,
            description: productInfo.description,
            price: productInfo.price,
            swapAmount: productInfo.swapAmount,
            isActive: productInfo.isActive,
            strategyContract: productInfo.strategyContract
        };
        
        store.dispatch('updateProductInfo', mappedProductInfo);
        // 获取所有产品ID
        // const productIds = await productManagerContract.methods.getAllProducts().call();
        
        // 遍历所有产品ID
        // for (const productId of productIds) {
        //     // 检查产品是否存在
        //     const exists = await productManagerContract.methods.productExists(productId).call();
            
        //     if (exists) {
        //         // 获取产品信息
        //         const productInfo = await productManagerContract.methods.getProduct(productId).call();
                
        //         // 从配置中获取目标产品名称
        //         const targetProductName = contractConfigs.productManager.targetProductName;
                
        //         // 检查产品名称是否匹配
        //         if (productInfo.name === targetProductName) {
        //             // 更新MobileSale合约地址
        //             updateContractConfig('mobileSale', {
        //                 address: productInfo.strategyContract // 使用 strategyContract 作为合约地址
        //             });
                    
        //             console.log('MobileSale contract address updated successfully');
                    
        //             // 更新存储合约地址
        //             const mobileSaleContract = getMobileSaleContract();
        //             const storageAddress = await mobileSaleContract.methods.storageContract().call();
                    
        //             if (storageAddress) {
        //                 updateContractConfig('saleStorage', {
        //                     address: storageAddress
        //                 });
        //                 console.log('SaleStorage contract address updated successfully');
        //             }

        //             // 将产品信息映射并存储到 store
        //             const mappedProductInfo = {
        //                 id: productInfo.id,
        //                 name: productInfo.name,
        //                 description: productInfo.description,
        //                 price: productInfo.price,
        //                 swapAmount: productInfo.swapAmount,
        //                 isActive: productInfo.isActive,
        //                 strategyContract: productInfo.strategyContract
        //             };
                    
        //             store.dispatch('updateProductInfo', mappedProductInfo);
                    
        //             return true;
        //         }
        //     }
        // }
        
        // console.log('No matching product found');
        return false;
    } catch (error) {
        console.error('Error updating contract addresses:', error);
        throw error;
    }
}

const THIRD_PARTY_PRODUCT_ID = 16;

export {
    getMobileSaleContract,
    getCoinContract,
    getProductManagerContract,
    getSaleStorageContract,
    updateContractConfig,
    getContractConfig,
    updateMobileSaleContractAddress,
    THIRD_PARTY_PRODUCT_ID
}   